import { useMemo } from 'react';
import { useCompanyId, useCompanyName } from '@clean-code/hooks/useCompanyId';

export function useAnalyticsCompanyContext() {
  const companyId = useCompanyId();
  const companyName = useCompanyName();
  return useMemo(
    () => ({ company_id: companyId, company_name: companyName }),
    [companyId, companyName]
  );
}
